import { FC, useMemo } from 'react';
import { connect } from 'react-bootstrap-formutil';
import { HomeAddressTypeEnum } from 'types/customer';
import ChnHomeAddress from './ChnHomeAddress';
import Common2HomeAddress from './Common2HomeAddress';
import CommonHomeAddress from './CommonHomeAddress';
import { getAddressTypeByResCountry } from './helper';
import { HomeAddressProps } from './type';
import UsaHomeAddress from './UsaHomeAddress';

const HomeAddress: FC<HomeAddressProps> = ({ homeAddressType, isSSN, legalResidenceCountry, ...restProps }) => {
    const curHomeAddressType = useMemo<HomeAddressTypeEnum>(
        () => homeAddressType || getAddressTypeByResCountry(isSSN, legalResidenceCountry),
        [homeAddressType, isSSN, legalResidenceCountry]
    );

    switch (curHomeAddressType) {
        case HomeAddressTypeEnum.CHN:
            return <ChnHomeAddress legalResidenceCountry={legalResidenceCountry} {...restProps} />;
        case HomeAddressTypeEnum.USA:
            return <UsaHomeAddress {...restProps} />;
        case HomeAddressTypeEnum.COMMON:
            return <CommonHomeAddress legalResidenceCountry={legalResidenceCountry} {...restProps} />;
        case HomeAddressTypeEnum.COMMON2:
            return <Common2HomeAddress legalResidenceCountry={legalResidenceCountry} {...restProps} />;
        default:
            const _checkNever: never = curHomeAddressType;

            return null;
    }
};

export default connect(HomeAddress);
export * from './helper';
export * from './type';
